import { apiCall, apiCallAdmin } from "../../services/api-service.js";

export const getFAQListApi = async () => {
  const response = await apiCallAdmin("GET", "help?application=Dock");
  return response.data;
};

export const reportAnIssueApi = async (data) => {
  const response = await apiCallAdmin("POST", "report_issue", data);
  return response;
};

export const getReportIssueTypeApi = async () => {
  const response = await apiCallAdmin("GET", "get_issue_type");
  return response.data;
};

export const getProfileDetailsApi = async () => {
  const response = await apiCallAdmin("GET", "basicprofile", null, {
    params: {},
  });
  return response;
};

export const getOrgLogoApi = async () => {
  const response = await apiCallAdmin("GET", "get_org_image");
  return response.data;
};

export const getAvailableDocksApi = async () => {
  const response = await apiCall("GET", "dock/dockmaster");
  return response;
};

export const getCountApi = async () => {
  const response = await apiCall("GET", "dashboard/count");
  return response;
};

export const getHistoryCountApi = async (date) => {
  const response = await apiCall("POST", "dashboard/history_count", {
    start_date: date,
  });
  return response;
};

export const getLocationFreeDocksApi = async () => {
  const response = await apiCall("GET", "dashboard/freedocks?search=");
  return response;
};

export const getLiveMonitorApi = async () => {
  const response = await apiCall("GET", "dashboard/livemonitor");
  return response;
};

export const getTimingListApi = async () => {
  const response = await apiCall("GET", "dashboard/timings");
  return response;
};
export const locationBasedDockOutDockInApi = async (month) => {
  const response = await apiCall(
    "POST",
    `dashboard/location_in_out?period=${month}&search=`,
    {}
  );
  return response;
};

export const sendOTPApi = async (data) => {
  const response = await apiCall("POST", "sent_otp", data);
  return response.data;
};

export const verifyOTPApi = async (data) => {
  const response = await apiCall("POST", "verify_otp", data);
  return response.data;
};

export const getAverageDurationApi = async (data) => {
  const response = await apiCall("POST", "dashboard/avarageduration", data);
  return response;
};

export const fetchDaywiseInData = async (month) => {
  const response = await apiCall("POST", "dashboard/daywisein", {
    period: month,
  });
  return response;
};

export const getDaywiseAverageData = async (params) => {
  const response = await apiCall("POST", "dashboard/dailyavarage", params);
  return response?.data?.daily_average || [];
};

export const getLocationListApi = async () => {
  const response = await apiCallAdmin("GET", "get_location");
  return response.data?.suggestionlist || [];
};

export const getDepartmentWiseData = async (params) => {
  const response = await apiCall("POST", "dashboard/departmentstatistics", params);
  return response?.data?.data || [];
};

export const getDepartmentWiseDockData = async (params) => {
  const response = await apiCall("POST", "dashboard/dock_statistics", params);
  return response?.data?.data || [];
};

export const getVehicleWiseData = async (params) => {
  const response = await apiCall("POST", "dashboard/vehiclelog", params);
  return response?.data?.data || [];
};

export const updateProfileImageApi = async (data) => {
  const response = await apiCallAdmin("POST", "user/image_update", data);
  return response;
};

export const getOrgListApi = async () => {
  const response = await apiCallAdmin("GET", "get_enrolled_orgs");
  return response;
};

export const getSwitchAccountApi = async (id) => {
  const response = await apiCallAdmin("GET", `switch_org/${id}`);
  return response;
};
